import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { postCoreDataSecurityAccessExplainerExportSlice } from './post';

export const coreDataSecurityAccessExplainerExportReducers = combineReducers({
	post: postCoreDataSecurityAccessExplainerExportSlice.asyncReducers
});

export const coreDataSecurityAccessExplainerExportWatchers = combineAllWatchers([
	postCoreDataSecurityAccessExplainerExportSlice.asyncWatchers
]);
